'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const MSGIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="MSGIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.5 23.5C20.7652 23.5 21.0196 23.3946 21.2071 23.2071C21.3946 23.0196 21.5 22.7652 21.5 22.5V6.475C21.5 4.89033 20.8705 3.37057 19.75 2.25004C18.6294 1.12951 17.1097 0.5 15.525 0.5H3.5C3.23478 0.5 2.98043 0.605357 2.79289 0.792893C2.60536 0.98043 2.5 1.23478 2.5 1.5V22.5C2.5 22.7652 2.60536 23.0196 2.79289 23.2071C2.98043 23.3946 3.23478 23.5 3.5 23.5H20.5Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 0.580078V4.50008C16.5 4.76529 16.6054 5.01965 16.7929 5.20718C16.9804 5.39472 17.2348 5.50008 17.5 5.50008H21.42"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 18.4729V12.4729L7 15.4729L8.5 12.4729V18.4729"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.51 12.4729H11.81C11.5293 12.4708 11.2555 12.5595 11.0294 12.7259C10.8033 12.8923 10.6372 13.1274 10.5558 13.396C10.4744 13.6647 10.4822 13.9525 10.578 14.2163C10.6737 14.4802 10.8523 14.706 11.087 14.8599L12.927 16.0869C13.1613 16.2411 13.3394 16.4668 13.4349 16.7305C13.5303 16.9941 13.5379 17.2816 13.4566 17.55C13.3753 17.8183 13.2094 18.0532 12.9836 18.2195C12.7579 18.3859 12.4844 18.4748 12.204 18.4729H10.51"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5127 14.4729V13.9729C18.5127 13.5751 18.3547 13.1935 18.0734 12.9122C17.7921 12.6309 17.4105 12.4729 17.0127 12.4729C16.6149 12.4729 16.2333 12.6309 15.952 12.9122C15.6707 13.1935 15.5127 13.5751 15.5127 13.9729V16.9729C15.5127 17.3707 15.6707 17.7523 15.952 18.0336C16.2333 18.3149 16.6149 18.4729 17.0127 18.4729C17.4105 18.4729 17.7921 18.3149 18.0734 18.0336C18.3547 17.7523 18.5127 17.3707 18.5127 16.9729V16.4729H17.5127"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

MSGIcon.propTypes = {
  sx: PropTypes.object
}
